import React, { useState, useEffect } from "react";
import { getPublicLandingSections, getLandingImageUrl } from "../../services/landingSectionsService";
import logoImage from "../../assets/logolp.png";

const SocialIcon = ({ href, children, title, iconColor, iconBgColor, hoverBg, hoverColor }) => {
  if (!href) return null;
  const color  = iconColor || "#60A5FA";
  const bg     = iconBgColor || "rgba(96, 165, 250,0.1)";
  const hBg    = hoverBg    || color;
  const hColor = hoverColor || "#ffffff";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        width: 38, height: 38, borderRadius: "10px",
        background: bg, color: color, flexShrink: 0,
        transition: "background .2s, color .2s, transform .2s", textDecoration: "none",
      }}
      onMouseEnter={e => {
        e.currentTarget.style.background = hBg;
        e.currentTarget.style.color = hColor;
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = bg;
        e.currentTarget.style.color = color;
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {children}
    </a>
  );
};

const LandingFooter = ({ appName = "" }) => {
  const currentYear = new Date().getFullYear();
  const [footerData, setFooterData] = useState(null);

  useEffect(() => {
    getPublicLandingSections()
      .then(data => { if (data?.footer) setFooterData(data.footer); })
      .catch(() => {});
  }, []);

  /* preview em tempo real: recebe postMessage do admin */
  useEffect(() => {
    const handler = (e) => {
      if (e.data?.type === "LP_PREVIEW_UPDATE" && e.data?.data?.footer !== undefined) {
        setFooterData(e.data.data.footer || null);
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  const f = (field, def) => {
    const v = footerData?.[field];
    return (v !== undefined && v !== null && v !== "") ? v : (def || "");
  };

  const socialIconColor    = f("socialIconColor");
  const socialIconBgColor  = f("socialIconBgColor");
  const socialIconHoverBg  = f("socialIconHoverBg");
  const socialIconHoverColor = f("socialIconHoverColor", "#ffffff");
  const footerBg   = f("bgColor");
  const brandColor = f("brandColor");
  const textColor  = f("textColor");
  const cnpj       = f("cnpj");
  const tagline    = f("tagline", "Plataforma omnichannel com IA para transformar seu atendimento e multiplicar resultados.");

  /* logo: usa upload do footer, ou logo padrão do site */
  const logoFile = f("logo");
  const logoUrl  = logoFile ? getLandingImageUrl(logoFile) : logoImage;

  /* social links */
  const socialLinks = [
    { key: "facebook",  href: f("facebook"),  title: "Facebook",
      icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg> },
    { key: "instagram", href: f("instagram"), title: "Instagram",
      icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg> },
    { key: "whatsapp",  href: f("whatsapp"),  title: "WhatsApp",
      icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg> },
    { key: "youtube",   href: f("youtube"),   title: "YouTube",
      icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M23.495 6.205a3.007 3.007 0 00-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 00.527 6.205a31.247 31.247 0 00-.522 5.805 31.247 31.247 0 00.522 5.783 3.007 3.007 0 002.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 002.088-2.088 31.247 31.247 0 00.5-5.783 31.247 31.247 0 00-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/></svg> },
    { key: "linkedin",  href: f("linkedin"),  title: "LinkedIn",
      icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg> },
    { key: "tiktok",    href: f("tiktok"),    title: "TikTok",
      icon: <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg> },
  ].filter(s => s.href);

  /* defaults das colunas — usados quando o admin não configurou nada */
  const COL_DEFAULTS = [
    {
      title: "Plataforma",
      links: [
        { label: "Funcionalidades", href: "#features" },
        { label: "Integrações",     href: "#integrations" },
        { label: "Planos",          href: "#pricing" },
        { label: "FAQ",             href: "#faq" },
        { label: "Blog",            href: "#blog" },
      ],
    },
    null,
    {
      title: "Legal",
      links: [
        { label: "Termos de Serviço", href: "/termos-de-servico" },
        { label: "Política de Uso",   href: "/politica-de-uso" },
        { label: "Privacidade",       href: "/politica-de-privacidade" },
      ],
    },
  ];

  /* colunas configuráveis: lê col1..col3, cada uma com título + 5 links */
  const buildCol = (n) => {
    const title = f(`col${n}title`);
    const links = [1, 2, 3, 4, 5].map(i => ({
      label: f(`col${n}l${i}`),
      href:  f(`col${n}h${i}`),
    })).filter(l => l.label && l.href);
    if (!title && links.length === 0) return COL_DEFAULTS[n - 1] || null;
    return { title, links };
  };
  const cols = [buildCol(1), buildCol(2), buildCol(3)].filter(Boolean);

  /* links legais sempre mostrados se a página existir */
  const legalLinks = [
    { label: "Termos de Serviço",   href: "/termos-de-servico" },
    { label: "Política de Uso",      href: "/politica-de-uso" },
    { label: "Privacidade",          href: "/politica-de-privacidade" },
  ];

  const hasColumns = cols.length > 0;
  const gridCols = hasColumns
    ? `1.9fr ${cols.map(() => "1fr").join(" ")}`
    : "1fr";

  return (
    <footer id="footer" style={{ background: footerBg || "#060818", position: "relative", overflow: "hidden" }}>
      <style>{`
        .lp-footer-inner {
          max-width: 1240px; margin: 0 auto;
          padding: 80px 40px 40px; position: relative; z-index: 1;
        }
        .lp-footer-grid {
          display: grid;
          grid-template-columns: ${gridCols};
          gap: 56px; padding-bottom: 64px;
          border-bottom: 1px solid rgba(255,255,255,0.07);
        }
        .lp-footer-logo-row { display: flex; align-items: center; gap: 10px; margin-bottom: 16px; }
        .lp-footer-logo-img { height: 36px; width: auto; display: block; }
        .lp-footer-brand-name { font-size: 20px; font-weight: 800; letter-spacing: -.4px; }
        .lp-footer-tagline {
          font-size: 14px; line-height: 1.7;
          color: rgba(255,255,255,0.4);
          max-width: 260px; margin-bottom: 24px;
        }
        .lp-footer-socials { display: flex; gap: 8px; flex-wrap: wrap; }
        .lp-footer-col-label {
          font-size: 11px; font-weight: 700;
          letter-spacing: 1.4px; text-transform: uppercase;
          color: rgba(255,255,255,0.28); margin-bottom: 20px;
        }
        .lp-footer-col-links { display: flex; flex-direction: column; gap: 13px; }
        .lp-footer-col-link {
          font-size: 14px; color: rgba(255,255,255,0.5);
          text-decoration: none; background: none; border: none;
          cursor: pointer; text-align: left; padding: 0; font-family: inherit;
          transition: color .2s;
        }
        .lp-footer-col-link:hover { color: rgba(255,255,255,0.9); }
        .lp-footer-bottom {
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 14px; padding-top: 36px;
          font-size: 13px; color: rgba(255,255,255,0.28);
        }
        .lp-footer-bottom-legal { display: flex; gap: 20px; flex-wrap: wrap; }
        .lp-footer-bottom-legal a {
          color: rgba(255,255,255,0.28); text-decoration: none;
          font-size: 13px; transition: color .2s;
        }
        .lp-footer-bottom-legal a:hover { color: rgba(255,255,255,0.65); }
        .lp-footer-glow {
          position: absolute; border-radius: 50%;
          filter: blur(100px); pointer-events: none; z-index: 0;
        }
        @media (max-width: 1024px) {
          .lp-footer-grid { grid-template-columns: 1fr 1fr !important; gap: 40px; }
        }
        @media (max-width: 600px) {
          .lp-footer-inner { padding: 56px 24px 32px; }
          .lp-footer-grid { grid-template-columns: 1fr !important; gap: 32px; }
          .lp-footer-bottom { flex-direction: column; align-items: flex-start; }
          .lp-footer-bottom-legal { flex-direction: column; gap: 10px; }
        }
      `}</style>

      <div className="lp-footer-glow" style={{ width: 480, height: 480, background: "#2563EB", top: -180, left: -120, opacity: 0.1 }} />
      <div className="lp-footer-glow" style={{ width: 320, height: 320, background: "#2563eb", bottom: -100, right: -80, opacity: 0.08 }} />

      <div className="lp-footer-inner">
        <div className="lp-footer-grid">

          {/* ── Coluna Brand ── */}
          <div>
            <div className="lp-footer-logo-row">
              <img src={logoUrl} alt={appName} className="lp-footer-logo-img" />
            </div>
            {tagline && (
              <p className="lp-footer-tagline" style={textColor ? { color: textColor } : undefined}>
                {tagline}
              </p>
            )}
            {socialLinks.length > 0 && (
              <div className="lp-footer-socials">
                {socialLinks.map(s => (
                  <SocialIcon
                    key={s.key}
                    href={s.href}
                    title={s.title}
                    iconColor={socialIconColor || "#60A5FA"}
                    iconBgColor={socialIconBgColor || "rgba(96, 165, 250,0.1)"}
                    hoverBg={socialIconHoverBg || undefined}
                    hoverColor={socialIconHoverColor || "#ffffff"}
                  >
                    {s.icon}
                  </SocialIcon>
                ))}
              </div>
            )}
          </div>

          {/* ── Colunas configuráveis ── */}
          {cols.map((col, ci) => (
            <div key={ci}>
              {col.title && <div className="lp-footer-col-label">{col.title}</div>}
              <div className="lp-footer-col-links">
                {col.links.map((link, li) => {
                  const isAnchor = link.href && link.href.startsWith("#");
                  return isAnchor ? (
                    <button
                      key={li}
                      className="lp-footer-col-link"
                      onClick={() => {
                        const el = document.getElementById(link.href.substring(1));
                        if (el) el.scrollIntoView({ behavior: "smooth" });
                        else window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                    >
                      {link.label}
                    </button>
                  ) : (
                    <a key={li} className="lp-footer-col-link" href={link.href}>{link.label}</a>
                  );
                })}
              </div>
            </div>
          ))}

        </div>

        <div className="lp-footer-bottom">
          <span>
            <strong style={{ color: "rgba(255,255,255,0.5)", fontWeight: 700 }}>{appName}</strong>
            {" "}© {currentYear} · Todos os direitos reservados
            {cnpj ? ` · CNPJ ${cnpj}` : ""}
          </span>
          <div className="lp-footer-bottom-legal">
            {legalLinks.map(link => (
              <a key={link.label} href={link.href}>{link.label}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
